import { UserMinus } from 'lucide-react';
import { EmptyState } from './shared';

export function DeletedAccountsTab({ deletedAccounts }) {
  if (deletedAccounts.length === 0) return <EmptyState icon={UserMinus} text="Aucun compte supprime" />;

  return (
    <div className="space-y-3">
      {deletedAccounts.map((a, i) => (
        <div key={i} className="bg-white dark:bg-neutral-800 rounded-lg border dark:border-neutral-700 p-4" data-testid={`deleted-account-${i}`}>
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center"><UserMinus className="w-4 h-4 text-red-500" /></div>
              <div>
                <p className="font-semibold text-sm text-neutral-900 dark:text-white">{a.first_name} {a.last_name}</p>
                <p className="text-xs text-neutral-500">{a.email}</p>
              </div>
            </div>
            <div className="text-right">
              <p className="text-xs text-neutral-400">{a.deleted_at ? new Date(a.deleted_at).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }) : '-'}</p>
              {a.company?.name && <p className="text-xs text-neutral-500">{a.company.name}</p>}
            </div>
          </div>
          <div className="bg-neutral-50 dark:bg-neutral-750 rounded-lg p-3 border dark:border-neutral-700">
            <p className="text-xs font-semibold text-neutral-500 uppercase tracking-wide mb-1">Raison de suppression</p>
            <p className="text-sm text-neutral-700 dark:text-neutral-300">{a.reason}</p>
          </div>
          {a.created_at && <p className="text-xs text-neutral-400 mt-2">Compte cree le {new Date(a.created_at).toLocaleDateString('fr-FR')}</p>}
        </div>
      ))}
    </div>
  );
}
